<template>
    <span v-if="orderItem.payment.payment_intent == 'Credit Card' && orderItem.payment.payment_method" :class="classes">
        <img :src="orderItem.payment.payment_method.cc_image_url" width="25"
            :alt="orderItem.payment.payment_method.brand" /> ending
        in {{ orderItem.payment.payment_method.last4 }}
    </span>
    <span v-else-if="orderItem.payment.payment_intent == 'ACH' && orderItem.payment.payment_method" :class="classes">
        {{ orderItem.payment.payment_method.bank_name }} ending in {{ orderItem.payment.payment_method.last4 }}
    </span>
    <span v-else :class="classes">
        {{ orderItem.payment.payment_intent }}
        <span v-if="orderItem.payment.payment_intent == 'Check' && orderItem.payment.cash.check_number">
            {{ orderItem.payment.cash.check_number }}
        </span>
        <span v-if="orderItem.payment.payment_intent == 'Account Balance' && this.isMTD()">Net-30</span>
    </span>
</template>

<script>
export default {
    data() {
        return {
            classes: 'text-secondary text-size-small'
        }
    },
    props: {
        orderItem: Object
    },
    methods: {
        isMTD() {
            return this.$page.props.auth.user.role == 'mtd'
        },
    }
}
</script>